// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for upload section */
.workflow-upload-section {
    margin-top: 24px;
    background-color: #ffffff;
    border-radius: 12px;
    padding: 20px 24px 24px;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);
    border: 1px solid #e5e7eb;
}

/* Heading + tentative charge */
.workflow-upload-heading {
    font-size: 1.05rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 8px;
}

.workflow-tentative-charge {
    font-size: 0.95rem;
    font-weight: 500;
    color: #2563eb;
    margin: 4px 0 16px;
}

/* Upload status */
.workflow-upload-status {
    margin-top: 8px;
    font-size: 0.9rem;
    color: #4b5563;
}

/* Individual input-file sections */
.upload-section {
    margin-bottom: 20px;
    max-width: 640px;
}

.upload-section-label {
    display: block;
    font-size: 0.9rem;
    font-weight: 500;
    color: #111827;
    margin-bottom: 6px;
}

/* Dropzone */
.upload-dropzone {
    border: 1.5px dashed #cbd5e1;
    padding: 18px;
    border-radius: 10px;
    cursor: pointer;
    margin-bottom: 16px;
    background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.upload-dropzone:hover {
    border-color: #2563eb;
    box-shadow: 0 6px 14px rgba(37, 99, 235, 0.08);
    background-color: #f5f7fb;
}

.upload-dropzone-text {
    margin: 0 0 10px;
    font-size: 0.9rem;
    color: #6b7280;
}

/* File cards */
.upload-file-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
}

.upload-file-card {
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 12px;
    width: 240px;
    background-color: #f9fafb;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.upload-file-name {
    font-size: 0.9rem;
    color: #111827;
}

/* Progress bar */
.upload-progress-bar {
    height: 8px;
    background-color: #e5e7eb;
    border-radius: 999px;
    overflow: hidden;
}

.upload-progress-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, #2563eb, #38bdf8);
    transition: width 0.25s ease;
}

.upload-progress-bar-fill-error {
    background: #dc2626;
}

.upload-progress-text {
    font-size: 0.8rem;
    color: #374151;
}

.upload-progress-text-error {
    color: #b91c1c;
}

/* Remove button */
.upload-remove-button {
    margin-top: 4px;
    font-size: 0.8rem;
    color: #2563eb;
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    align-self: flex-start;
    padding: 0;
}

.upload-remove-button:hover {
    color: #1d4ed8;
}

/* Primary upload button */
.upload-primary-button {
    padding: 9px 16px;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #ffffff;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.25);
    transition: transform 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;
}

.upload-primary-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(37, 99, 235, 0.3);
}

.upload-primary-button:active {
    transform: translateY(0);
    box-shadow: 0 3px 8px rgba(37, 99, 235, 0.2);
}

/* Launch area */
.workflow-launch-container {
    margin-top: 16px;
}

.workflow-all-complete-text {
    font-weight: 600;
    color: #16a34a;
    margin-bottom: 10px;
    font-size: 0.95rem;
}

.workflow-launch-button {
    padding: 10px 18px;
    background: linear-gradient(135deg, #0ea5e9, #2563eb);
    color: #ffffff;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.25);
    transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.workflow-launch-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(37, 99, 235, 0.3);
}

.workflow-launch-button:active {
    transform: translateY(0);
    box-shadow: 0 3px 8px rgba(37, 99, 235, 0.2);
}

/* Modal (react-modal) */
.workflow-modal-overlay {
    background-color: rgba(15, 23, 42, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.workflow-modal {
    width: 420px;
    max-width: 90%;
    background-color: #ffffff;
    border-radius: 14px;
    padding: 22px 24px 20px;
    outline: none;
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.25);
    border: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.workflow-modal-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 10px;
}

.workflow-modal-body {
    font-size: 0.95rem;
    color: #374151;
    text-align: center;
    margin: 0 0 10px;
}

.workflow-modal-charge {
    font-size: 0.95rem;
    font-weight: 500;
    color: #2563eb;
    margin: 4px 0 14px;
}

.workflow-modal-buttons {
    display: flex;
    gap: 10px;
    justify-content: center;
    width: 100%;
}

.workflow-modal-button {
    padding: 9px 18px;
    border-radius: 999px;
    border: none;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    min-width: 90px;
    transition: transform 0.1s ease, box-shadow 0.1s ease, background-color 0.1s ease;
}

.workflow-modal-button-confirm {
    background: linear-gradient(135deg, #16a34a, #22c55e);
    color: #ffffff;
    box-shadow: 0 4px 10px rgba(22, 163, 74, 0.25);
}

.workflow-modal-button-confirm:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(22, 163, 74, 0.3);
}

.workflow-modal-button-confirm:active {
    transform: translateY(0);
    box-shadow: 0 3px 8px rgba(22, 163, 74, 0.2);
}

.workflow-modal-button-cancel {
    background-color: #f3f4f6;
    color: #111827;
}

.workflow-modal-button-cancel:hover {
    background-color: #e5e7eb;
}

.workflow-modal-button-cancel:active {
    background-color: #d1d5db;
}`, "",{"version":3,"sources":["webpack://./src/css/FileUpload.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,aAAa;AACb;IACI,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,6DAA6D;IAC7D,uFAAuF;AAC3F;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,iBAAiB;IACjB,qDAAqD;IACrD,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,8CAA8C;IAC9C,2EAA2E;AAC/E;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,8CAA8C;IAC9C,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA,wBAAwB;AACxB;IACI,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,8CAA8C;IAC9C,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iFAAiF;AACrF;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* Container for upload section */\n.workflow-upload-section {\n    margin-top: 24px;\n    background-color: #ffffff;\n    border-radius: 12px;\n    padding: 20px 24px 24px;\n    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);\n    border: 1px solid #e5e7eb;\n}\n\n/* Heading + tentative charge */\n.workflow-upload-heading {\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: #111827;\n    margin: 0 0 8px;\n}\n\n.workflow-tentative-charge {\n    font-size: 0.95rem;\n    font-weight: 500;\n    color: #2563eb;\n    margin: 4px 0 16px;\n}\n\n/* Upload status */\n.workflow-upload-status {\n    margin-top: 8px;\n    font-size: 0.9rem;\n    color: #4b5563;\n}\n\n/* Individual input-file sections */\n.upload-section {\n    margin-bottom: 20px;\n    max-width: 640px;\n}\n\n.upload-section-label {\n    display: block;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: #111827;\n    margin-bottom: 6px;\n}\n\n/* Dropzone */\n.upload-dropzone {\n    border: 1.5px dashed #cbd5e1;\n    padding: 18px;\n    border-radius: 10px;\n    cursor: pointer;\n    margin-bottom: 16px;\n    background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);\n    transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\n.upload-dropzone:hover {\n    border-color: #2563eb;\n    box-shadow: 0 6px 14px rgba(37, 99, 235, 0.08);\n    background-color: #f5f7fb;\n}\n\n.upload-dropzone-text {\n    margin: 0 0 10px;\n    font-size: 0.9rem;\n    color: #6b7280;\n}\n\n/* File cards */\n.upload-file-cards {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 14px;\n}\n\n.upload-file-card {\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    padding: 10px 12px;\n    width: 240px;\n    background-color: #f9fafb;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.upload-file-name {\n    font-size: 0.9rem;\n    color: #111827;\n}\n\n/* Progress bar */\n.upload-progress-bar {\n    height: 8px;\n    background-color: #e5e7eb;\n    border-radius: 999px;\n    overflow: hidden;\n}\n\n.upload-progress-bar-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #2563eb, #38bdf8);\n    transition: width 0.25s ease;\n}\n\n.upload-progress-bar-fill-error {\n    background: #dc2626;\n}\n\n.upload-progress-text {\n    font-size: 0.8rem;\n    color: #374151;\n}\n\n.upload-progress-text-error {\n    color: #b91c1c;\n}\n\n/* Remove button */\n.upload-remove-button {\n    margin-top: 4px;\n    font-size: 0.8rem;\n    color: #2563eb;\n    background: none;\n    border: none;\n    cursor: pointer;\n    text-decoration: underline;\n    align-self: flex-start;\n    padding: 0;\n}\n\n.upload-remove-button:hover {\n    color: #1d4ed8;\n}\n\n/* Primary upload button */\n.upload-primary-button {\n    padding: 9px 16px;\n    background: linear-gradient(135deg, #2563eb, #1d4ed8);\n    color: #ffffff;\n    border: none;\n    border-radius: 999px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.25);\n    transition: transform 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;\n}\n\n.upload-primary-button:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 14px rgba(37, 99, 235, 0.3);\n}\n\n.upload-primary-button:active {\n    transform: translateY(0);\n    box-shadow: 0 3px 8px rgba(37, 99, 235, 0.2);\n}\n\n/* Launch area */\n.workflow-launch-container {\n    margin-top: 16px;\n}\n\n.workflow-all-complete-text {\n    font-weight: 600;\n    color: #16a34a;\n    margin-bottom: 10px;\n    font-size: 0.95rem;\n}\n\n.workflow-launch-button {\n    padding: 10px 18px;\n    background: linear-gradient(135deg, #0ea5e9, #2563eb);\n    color: #ffffff;\n    border: none;\n    border-radius: 999px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    box-shadow: 0 4px 10px rgba(37, 99, 235, 0.25);\n    transition: transform 0.1s ease, box-shadow 0.1s ease;\n}\n\n.workflow-launch-button:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 14px rgba(37, 99, 235, 0.3);\n}\n\n.workflow-launch-button:active {\n    transform: translateY(0);\n    box-shadow: 0 3px 8px rgba(37, 99, 235, 0.2);\n}\n\n/* Modal (react-modal) */\n.workflow-modal-overlay {\n    background-color: rgba(15, 23, 42, 0.35);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.workflow-modal {\n    width: 420px;\n    max-width: 90%;\n    background-color: #ffffff;\n    border-radius: 14px;\n    padding: 22px 24px 20px;\n    outline: none;\n    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.25);\n    border: 1px solid #e5e7eb;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.workflow-modal-title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: #111827;\n    margin: 0 0 10px;\n}\n\n.workflow-modal-body {\n    font-size: 0.95rem;\n    color: #374151;\n    text-align: center;\n    margin: 0 0 10px;\n}\n\n.workflow-modal-charge {\n    font-size: 0.95rem;\n    font-weight: 500;\n    color: #2563eb;\n    margin: 4px 0 14px;\n}\n\n.workflow-modal-buttons {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    width: 100%;\n}\n\n.workflow-modal-button {\n    padding: 9px 18px;\n    border-radius: 999px;\n    border: none;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    min-width: 90px;\n    transition: transform 0.1s ease, box-shadow 0.1s ease, background-color 0.1s ease;\n}\n\n.workflow-modal-button-confirm {\n    background: linear-gradient(135deg, #16a34a, #22c55e);\n    color: #ffffff;\n    box-shadow: 0 4px 10px rgba(22, 163, 74, 0.25);\n}\n\n.workflow-modal-button-confirm:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 14px rgba(22, 163, 74, 0.3);\n}\n\n.workflow-modal-button-confirm:active {\n    transform: translateY(0);\n    box-shadow: 0 3px 8px rgba(22, 163, 74, 0.2);\n}\n\n.workflow-modal-button-cancel {\n    background-color: #f3f4f6;\n    color: #111827;\n}\n\n.workflow-modal-button-cancel:hover {\n    background-color: #e5e7eb;\n}\n\n.workflow-modal-button-cancel:active {\n    background-color: #d1d5db;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
